import React, { useState, useEffect } from 'react'
import { Card, CardBody, Row, Col, FormGroup, Label, Button, Alert } from 'reactstrap'
import { getInstructorIdData as getInstructorDataforStudents } from '../../lib/sessionscheduleview'
import { updateData } from '../../lib/sessionschedule'
import { getDataforInstructorActiveStudent } from '../../lib/classdetailview'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { useParams } from 'react-router-dom'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { InstructorScheduleTable } from './InstructorScheduleTable'
import ScheduleAddModal from './ScheduleAddModal'

const InstructorScheduleList = () => {
	const { studentId } = useParams()
	const [instructorStudent, setInstructorStudent] = useState([])
	const [instructorSchedule, setInstructorSchedule] = useState([])
	const [selectedStudent, setSelectedStudent] = useState()
	const [error, setError] = useState('')
	const [loading, setLoading] = useState(true)
	const [isDarkMode, setIsDarkMode] = useState(false)
	const { user } = useAuth()
	const [isModalOpen, setIsModalOpen] = useState(false)

	const getInstructorStudent = async () => {
		if (!user?.id) {
			setLoading(false)
			return
		}

		try {
			setLoading(true)
			const students = await getDataforInstructorActiveStudent(user.id)
			if (students && students.length > 0) {
				setInstructorStudent(students)
				setSelectedStudent(studentId ? studentId : students[0].studentId)
				getInstructorScheduleData(studentId ? studentId : students[0].studentId)
			}
		} catch (error) {
			console.error('Error fetching instructor students:', error)
			setError('Failed to load students')
		} finally {
			setLoading(false)
		}
	}

	const getInstructorScheduleData = async (studentId) => {
		if (!user?.id || !studentId) return

		try {
			setInstructorSchedule([])
			const sched = await getInstructorDataforStudents(user.id, studentId)
			setInstructorSchedule(sched)
		} catch (error) {
			console.error('Error fetching instructor schedule data:', error)
			setError('Failed to load schedule data')
		}
	}

	const changeTaskStatus = async (scheduleId, status) => {
		try {
			await updateData({
				id: scheduleId,
				status: status
			})
			getInstructorScheduleData(selectedStudent)
		} catch (error) {
			console.error('Error updating task status:', error)
			setError('Failed to update status')
		}
	}

	const handleAddTask = () => {
		setIsModalOpen(true)
	}

	const toggleModal = () => {
		setIsModalOpen(!isModalOpen)
	}

	useEffect(() => {
		if (selectedStudent) {
			getInstructorScheduleData(selectedStudent)
		}
	}, [selectedStudent])

	useEffect(() => {
		if (user?.id) {
			getInstructorStudent()
		}
	}, [user?.id])

	useEffect(() => {
		const checkDarkMode = () => {
			setIsDarkMode(document.body.classList.contains('dark-only'))
		}
		checkDarkMode()
		const observer = new MutationObserver(checkDarkMode)
		observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })
		return () => observer.disconnect()
	}, [])

	if (loading) {
		return (
			<Card style={{ backgroundColor: isDarkMode ? '#2a2d35' : '#fff' }}>
				<CardBody style={{ backgroundColor: isDarkMode ? '#2a2d35' : '#fff' }}>
					<div className="text-center">
						<div className="spinner-border" role="status">
							<span className="visually-hidden">Loading...</span>
						</div>
						<p className="mt-2" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>Loading schedule data...</p>
					</div>
				</CardBody>
			</Card>
		)
	}

	return (
		<StudentTopMenuLayout activeMenu="Schedule" pageName="Schedule" showPageNotes={true}>
			<Card style={{ backgroundColor: isDarkMode ? '#2a2d35' : '#fff' }}>
				<CardBody style={{ backgroundColor: isDarkMode ? '#2a2d35' : '#fff' }}>
					<div className="d-flex pb-1 justify-content-between align-items-center mb-2">
						<div>
							<h3 style={{ color: isDarkMode ? '#fff' : 'inherit' }}>{`${studentId ? 'Student' : 'Instructor'} Schedule`}</h3>
						</div>
						<div className="d-flex">
							<div className="ticket-btn-grp">
								<button onClick={handleAddTask} className="btn btn-primary">
									{`${studentId ? 'Add New Date' : 'Schedule New Meeting'}`}
								</button>
							</div>
						</div>
					</div>

					{error && (
						<Alert color="danger" className="alert-dismissible fade show" role="alert">
							<strong>Error:</strong> {error}
							<Button type="button" className="btn-close" onClick={() => setError('')} aria-label="Close"></Button>
						</Alert>
					)}

					{!studentId && (
						<Row>
							<Col lg="3">
								<FormGroup>
									<Label className="form-control-label" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>Student</Label>
									<select
										value={selectedStudent}
										onChange={(e) => setSelectedStudent(e.target.value)}
										className="form-control"
										style={{
											backgroundColor: isDarkMode ? '#2a2d35' : '#fff',
											color: isDarkMode ? '#fff' : 'inherit'
										}}
									>
										{instructorStudent.map((data, ix) => (
											<option key={ix} value={data.studentId}>
												{data.studentName + ' ' + data.studentSurname}
											</option>
										))}
									</select>
								</FormGroup>
							</Col>
						</Row>
					)}

					<hr className="mt-2" />
					<div className="table-responsive">
						<InstructorScheduleTable
							data={instructorSchedule}
							onStatusChange={changeTaskStatus}
							isDarkMode={isDarkMode}
							showIdColumn={true}
							showStudentColumn={!studentId}
							noDataComponent="No schedule data found"
						/>
					</div>
					<ScheduleAddModal
						isOpen={isModalOpen}
						toggle={toggleModal}
						instructorId={user?.id}
						studentId={studentId || selectedStudent}
						onSave={getInstructorScheduleData}
						isDarkMode={isDarkMode}
					/>
				</CardBody>
			</Card>
		</StudentTopMenuLayout>
	)
}

export { InstructorScheduleList }
